<template>
  <router-view :key="key" />
</template>

<script>
export default {
  name: "App",
  computed: {
    key() {
      return this.$route.name
        ? this.$route.name + +new Date()
        : this.$route + +new Date();
    },
  },
  beforeCreate() {},
  created() {},
};
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  //max-width: 750px;
  width: 100%;
  margin: auto;
}
</style>
